const urlRegex = new RegExp(
  "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
)
export const isUrlValid = (string: string): boolean => urlRegex.test(string)
